import { HTMLInputTypeAttribute, useState } from "react";
import "./styles.css";
import React from "react";

export interface textboxProps {
    id: string;
    label?: string;
    value: any;
    onChange: (field: string, value: string) => any;
    setFocus?: boolean;
    isNotValid?: boolean;
    requiredIdentifier?: boolean;
    disabled?: boolean;
    height: string;
    maxLength: number;
    validationFunc?: (val: any, maxLength: number) => {};
    errorMessage: string;
}

function TextArea(props: textboxProps) {
    const [fieldValue, setFieldValue] = useState(props.value);
    const [errorMessage, setErrorMessage] = useState("");
    React.useEffect(() => {
        setFieldValue(props.value);
        setErrorMessage(props.errorMessage);
    }, [props.value, props.errorMessage]);

    const handleInputChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
        setFieldValue(e.currentTarget.value);
        props.onChange(props.id, e.currentTarget.value);
    };

    const validField = (e: React.FormEvent<HTMLTextAreaElement>) => {
        if (props.validationFunc) {
            if (!props.validationFunc(e.currentTarget.value, props.maxLength)) {
                setErrorMessage("Field cannot be blank, Length must be less than " + props.maxLength);
            } else {
                setErrorMessage("");
            }
        }
    };

    return (
        <div
            className="textBoxContainer"
            key={"Main" + props.id}
        >
            <div className="textBoxCol1">
                <label className="g-label">{props.label}</label>
                <small className="asterisk">{props.requiredIdentifier ? "*" : ""}</small>
            </div>
            <div className="textBoxCol2">
                <textarea
                    disabled={props.disabled}
                    className={!(errorMessage == "") ? "g-TextBox-default validationFailed " : "g-TextBox-default "}
                    onChange={handleInputChange}
                    // `undefined` would make the textarea uncontrolled, and it would keep showing the old text.
                    value={fieldValue ?? ""}
                    autoFocus={props.setFocus}
                    autoComplete="off"
                    aria-autocomplete="none"
                    style={{ height: props.height }}
                    onBlur={validField}
                    title={errorMessage}
                ></textarea>
            </div>
        </div>
    );
}
export default TextArea;
